import React from 'react'
import Card from '../../../UI/CardView'
import { useContentfulContext } from '../../../../contexts/ContentfulContext'

const GalleryView = ({ rowData, handleOnClickCallback }) => {
    const { enums } = useContentfulContext();

    return (
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
            {rowData.map((item, index) => (
                <Card
                    key={index}
                    images={item.icon_url}
                    imageAlt={item.imageAlt}
                    title={item.template_name}
                    onClick={() => {
                        if(item?.isDisabled) return;
                        handleOnClickCallback(item)
                    }} // pass the entire item
                    isDisabled={item?.isDisabled}
                    isNoPreviewType={item.type === enums.templateTypes.no_preview.id ? true : false}
                />
            ))}
        </div>
    )
}

export default GalleryView